"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  route: {
    dashboard: 'Dashboard',
    documentation: 'Documentation',
    guide: 'Guide',
    permission: 'Permission',
    pagePermission: 'Page Permission',
    rolePermission: 'Role Permission',
    directivePermission: 'Directive Permission',
    icons: 'Icons',
    components: 'Components',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'Count To',
    componentMixin: 'Mixin',
    backToTop: 'Back To Top',
    draggableDialog: 'Draggable Dialog',
    draggableKanban: 'Draggable Kanban',
    draggableList: 'Draggable List',
    draggableSelect: 'Draggable Select',
    charts: 'Charts',
    barChart: 'Bar Chart',
    lineChart: 'Line Chart',
    mixedChart: 'Mixed Chart',
    example: 'Example',
    nested: 'Nested Routes',
    menu1: 'Menu 1',
    'menu1-1': 'Menu 1-1',
    'menu1-2': 'Menu 1-2',
    'menu1-2-1': 'Menu 1-2-1',
    'menu1-2-2': 'Menu 1-2-2',
    'menu1-3': 'Menu 1-3',
    menu2: 'Menu 2',
    table: 'Table',
    dynamicTable: 'Dynamic Table',
    draggableTable: 'Draggable Table',
    inlineEditTable: 'Inline Edit Table',
    complexTable: 'Complex Table',
    tab: 'Tab',
    form: 'Form',
    createArticle: 'Create Article',
    editArticle: 'Edit Article',
    articleList: 'Article List',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    errorLog: 'Error Log',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    selectExcel: 'Export Selected',
    mergeHeader: 'Merge Header',
    uploadExcel: 'Upload Excel',
    zip: 'Zip',
    pdf: 'PDF',
    exportZip: 'Export Zip',
    theme: 'Theme',
    clipboard: 'Clipboard',
    i18n: 'I18n',
    externalLink: 'External Link',
    profile: 'Profile',
    adminManagement: {
      title: 'Admin Management',
      admins: {
        title: 'Admins',
        add: 'Add Admin',
        edit: 'Edit Admin'
      },
      roles: {
        title: 'Roles',
        manage: 'Manage Role'
      }
    },
    employees: {
      title: 'Employees',
      add: 'Add Employees',
      edit: 'Edit Employees',
      login: 'Alembic Login'
    },
    userManagement: {
      title: 'User Management',
      users: {
        title: 'User',
        add: 'Add User',
        edit: 'Edit User'
      }
    },
    usersProfilesManagement: {
      title: 'Users Profiles Management',
      profiles: {
        title: 'Users Profiles',
        add: 'Add Profile',
        edit: 'Edit Profile'
      }
    },
    reviews: {
      title: 'Feedback',
      name: 'Feedback'
    },
    marketing: {
      title: 'Marketing',
      name: 'Marketing'
    },
    settingManagement: {
      title: 'Setting Management',
      settings: {
        title: 'Setting',
        add: 'Add Setting',
        edit: 'Edit Setting'
      }
    },
    bannerManagement: {
      title: 'Banner Management',
      banners: {
        title: 'Banner',
        add: 'Add Banner',
        edit: 'Edit Banner'
      }
    },
    productManagement: {
      title: 'Product Management',
      brand: {
        title: 'Brand',
        add: 'Add Brand',
        manage: 'Manage Brand'
      },
      attribute: {
        title: 'Attribute',
        add: 'Add Attribute',
        edit: 'Edit Attribute'
      },
      attributevalue: {
        title: 'Attribute Value',
        add: 'Add Attribute Value',
        edit: 'Edit Attribute Value',
        manage: 'Manage Attribute Value'
      },
      product: {
        title: 'Product',
        manage: 'Manage Product',
        import: 'Import Product'
      },
      category: {
        title: 'Category',
        manage: 'Manage Category',
        edit: 'Edit Category',
        add: 'Add Category'
      },
      measurement: {
        title: 'Measurement',
        manage: 'Manage Measurement',
        edit: 'Edit Measurement',
        add: 'Add Measurement'
      }
    },
    orderManagement: {
      title: 'Order Management',
      orders: {
        title: 'Order',
        add: 'Add Order',
        edit: 'Edit Order'
      },
      transaction: {
        title: 'Transaction',
        edit: 'Edit Transaction',
        add: 'Add Transaction'
      },
      coupons: {
        title: 'Coupon',
        add: 'Add Coupon',
        edit: 'Edit Coupon'
      }
    },
    customerManagement: {
      title: 'Customer Management',
      organization: {
        title: 'Organization',
        add: 'Add Organization',
        edit: 'Edit Organization'
      },
      contact: {
        title: 'Contact',
        add: 'Add Contact',
        edit: 'Edit Contact'
      },
      address: {
        title: 'Address',
        add: 'Add Address',
        edit: 'Edit Address'
      }
    },
    master: {
      title: 'Master',
      tax: {
        title: 'Tax',
        add: 'Add Tax',
        edit: 'Edit Tax',
        manage: 'Manage'
      },
      measurementunits: {
        title: 'Unit Of Measurement',
        add: 'Add Unit Of Measurement',
        edit: 'Edit Unit Of Measurement',
        manage: 'Manage '
      },
      homePages: {
        title: 'Home Page',
        add: 'Add Home Page',
        edit: 'Edit Home Page',
        manage: 'Manage '
      }
    },
    locations: {
      title: 'Location Management',
      titleShort: 'Location',
      countries: {
        title: 'Country',
        add: 'Add Country',
        edit: 'Edit Country'
      },
      states: {
        title: 'State',
        add: 'Add State',
        edit: 'Edit State'
      },
      cities: {
        title: 'City',
        add: 'Add City',
        edit: 'Edit City'
      },
      pincode: {
        title: 'Pincode',
        add: 'Add Pincode',
        edit: 'Edit Pincode',
        manage: 'Manage Pincode'
      }
    },
    notifications: {
      title: 'Announcements',
      manage: 'Manage Announcements'
    },
    faqs: {
      title: 'FAQs',
      add: 'Add FAQs',
      edit: 'Edit FAQs'
    },
    rules: {
      title: 'Rules',
      add: 'Add Rules',
      edit: 'Edit Rules'
    },
    scores: {
      title: 'Scores'
    },
    industryManagement: {
      title: 'Industry Management',
      industry: {
        title: 'Industry',
        add: 'Add Industry',
        edit: 'Edit Industry'
      }
    },
    driverManagement: {
      title: 'Driver Management',
      driver: {
        title: 'Driver',
        add: 'Add Driver',
        edit: 'Edit Driver',
        manage: 'Manage Driver'
      },
      vehicle: {
        title: 'Vehicles',
        add: 'Add Vehicle',
        edit: 'Edit Vehicle',
        manage: 'Manage Vehicle'
      }
    },
    gameLevels: {
      title: 'Game Levels',
      add: 'Add Game Levels',
      edit: 'Edit Game Levels'
    },
    redemption: {
      title: 'Redemption'
    },
    boosters: {
      title: 'Boosters',
      add: 'Add Boosters',
      edit: 'Edit Boosters'
    },
    boostersTypes: {
      title: 'Boosters Types',
      add: 'Add Boosters Types',
      edit: 'Edit Boosters Types'
    },
    achievements: {
      title: 'Achievements',
      add: 'Add Achievements',
      edit: 'Edit Ahievements'
    },
    prizes: {
      title: 'Prizes',
      add: 'Add Prizes',
      edit: 'Edit Prizes'
    }
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    theme: 'Theme',
    size: 'Global Size',
    profile: 'Profile'
  },
  login: {
    title: 'Admin Login Form',
    logIn: 'Login',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    any: 'any',
    recover: 'Send Recovery Mail',
    recoverTitle: ' Password recovery',
    thirdparty: 'Or connect with',
    thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
  },
  documentation: {
    documentation: 'Documentation'
  },
  permission: {
    createRole: 'New Role',
    editPermission: 'Edit',
    roles: 'Your roles',
    switchRoles: 'Switch roles',
    tips: 'In some cases, using v-permission will have no effect. For example: Element-UI  el-tab or el-table-column and other scenes that dynamically render dom. You can only do this with v-if.',
    delete: 'Delete',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  guide: {
    description: 'The guide page is useful for some people who entered the project for the first time. You can briefly introduce the features of the project. Demo is based on ',
    button: 'Show Guide'
  },
  components: {
    documentation: 'Documentation',
    tinymceTips: 'Rich text is a core feature of the management backend, but at the same time it is a place with lots of pits. In the process of selecting rich texts, I also took a lot of detours. The common rich texts on the market have been basically used, and I finally chose Tinymce. See the more detailed rich text comparison and introduction.',
    stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
    backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
    backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
    imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.'
  },
  table: {
    dynamicTips1: 'Fixed header, sorted by header order',
    dynamicTips2: 'Not fixed header, sorted by click order',
    dragTips1: 'The default order',
    dragTips2: 'The after dragging order',
    title: 'Title',
    importance: 'Importance',
    type: 'Type',
    remark: 'Remark',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    reviewer: 'Reviewer',
    id: 'ID',
    date: 'Date',
    author: 'Author',
    readings: 'Readings',
    status: 'Status',
    actions: 'Actions',
    edit: 'Edit',
    publish: 'Publish',
    draft: 'Draft',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    createdDate: 'Created',
    deleteConfirmation: 'Do you want to delete, {name}?',
    deleteCanceled: 'Delete canceled',
    sort: {
      id: {
        asc: 'ID Ascending',
        desc: 'ID Descending'
      },
      enable: {
        enabled: 'Enabled',
        disabled: 'Disabled'
      }
    }
  },
  example: {
    warning: 'Creating and editing pages cannot be cached by keep-alive because keep-alive\'s \'include\' currently does not support caching based on routes, so now it\'s cached based on component name. If you want to achieve a similar caching effect, you can use a browser caching scheme such as localStorage. Or don\'t use keep-alive\'s \'include\' to cache all pages directly. See details'
  },
  errorLog: {
    tips: 'Please click the bug icon in the upper right corner',
    description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction'
  },
  excel: {
    export: 'Export',
    selectedExport: 'Export Selected Items',
    placeholder: 'Please enter the file name (default excel-list)'
  },
  zip: {
    export: 'Export',
    placeholder: 'Please enter the file name (default file)'
  },
  pdf: {
    tips: 'Here we use window.print() to implement the feature of downloading PDF.'
  },
  theme: {
    change: 'Change Theme',
    documentation: 'Theme documentation',
    tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  settings: {
    title: 'Page style setting',
    theme: 'Theme Color',
    showTagsView: 'Open Tags-View',
    showSidebarLogo: 'Sidebar Logo',
    fixedHeader: 'Fixed Header',
    sidebarTextTheme: 'Sidebar Text Theme'
  },
  admin: {
    fullName: 'Full Name',
    email: 'Email',
    contactNumber: 'Contact Number',
    enabled: 'Enabled',
    role: {
      name: 'Name',
      enabled: 'Enabled'
    }
  },
  location: {
    country: {
      name: 'Name',
      code: 'Code',
      enabled: 'Enabled'
    },
    state: {
      name: 'Name',
      code: 'Code',
      enabled: 'Enabled',
      country: 'Country'
    },
    city: {
      name: 'Name',
      code: 'Code',
      enabled: 'Enabled',
      country: 'Country',
      state: 'State'
    }
  },
  geolocation: {
    prompt: {
      title: 'Geolocation Permission',
      message: 'Kindly allow us to access your current location',
      nonCompatibleBrowser: 'You are using non compatible browser'
    }
  },
  master: {
    title: 'Master',
    tax: {
      name: 'Tax',
      enabled: 'Enabled'
    }
  },
  address: {
    name: 'Name',
    enabled: 'Enabled'
  },
  attribute: {
    name: 'Attribute',
    enabled: 'Enabled'
  },
  attributeValue: {
    name: 'Attribute Value',
    enabled: 'Enabled'
  },
  brand: {
    name: 'Brand',
    enabled: 'Enabled'
  },
  category: {
    name: 'Category',
    enabled: 'Enabled'
  },
  contact: {
    name: 'Contact',
    enabled: 'Enabled'
  },
  order: {
    name: 'Order Reference',
    enabled: 'Enabled',
    userName: 'User Name',
    mobile: 'Mobile Number',
    email: 'Email Address'
  },
  measurementunits: {
    name: 'Unit Of Measurement',
    enabled: 'Enabled'
  },
  organization: {
    name: 'Organization',
    enabled: 'Enabled'
  },
  pincode: {
    name: 'Name',
    code: 'Pincode',
    enabled: 'Enabled'
  },
  coupon: {
    enabled: 'Enabled',
    name: 'Name',
    code: 'Code'
  },
  user: {
    enabled: 'Enabled',
    fullName: 'Full Name',
    email: 'Email',
    mobileNumber: 'Mobile Number'
  },
  product: {
    enabled: 'Enabled',
    name: 'Name',
    category: 'Category',
    attribute: 'Attribute'
  },
  industry: {
    name: 'Industry',
    enabled: 'Enabled'
  },
  driver: {
    enabled: 'Enabled',
    fullName: 'Full Name',
    email: 'Email',
    mobileNumber: 'Mobile Number'
  },
  vehicle: {
    name: 'Vehicle',
    enabled: 'Enabled'
  },
  global: {
    form: {
      save: 'Save',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      reset: 'Reset'
    },
    common: {
      ok: 'Ok',
      error: 'Error'
    }
  },
  notifications: {
    enabled: 'Enabled',
    title: 'Title',
    message: 'Sub Title',
    state: 'State',
    city: 'City',
    send: 'Send'
  }
};